module.exports = __webpack_public_path__ + "assets/img/lxs1.7342d7d4.png";